import React from 'react';
import { View, TouchableOpacity, StyleSheet, Platform } from 'react-native';

const STABLE_BRAND_COLORS = [
  '#FF6B35', '#4A90E2', '#7ED321', '#F7931E', '#9B59B6',
  '#E74C3C', '#1ABC9C', '#34495E', '#F39C12',
];

export interface RaisedCenterActionProps {
  size?: number; // diameter of the white circle
  glowColor?: string;
  onPress?: () => void;
}

const RaisedCenterAction: React.FC<RaisedCenterActionProps> = ({ size = 64, glowColor = '#FF6B35', onPress }) => {
  const logoShadowStyle = Platform.select({
    web: { boxShadow: `0 0 30px ${glowColor}` },
    default: { shadowColor: glowColor },
  });

  return (
    <TouchableOpacity activeOpacity={0.85} onPress={onPress} style={styles.buttonWrap}>
      <View style={[styles.logoCircle, { width: size, height: size, borderRadius: size / 2 }, logoShadowStyle]}>
        <View style={styles.puzzleGrid}>
          {STABLE_BRAND_COLORS.map((color, idx) => (
            <View key={idx} style={[styles.puzzlePiece, { backgroundColor: color }]} />
          ))}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  buttonWrap: { alignItems: 'center', justifyContent: 'center' },
  logoCircle: {
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {},
      default: { shadowOffset: { width: 0, height: 0 }, shadowOpacity: 1.0, shadowRadius: 30, elevation: 25 },
    }),
  },
  puzzleGrid: {
    width: 36,
    height: 36,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  puzzlePiece: {
    width: 10,
    height: 10,
    borderRadius: 2,
    ...Platform.select({
      web: { boxShadow: '0px 1px 2px rgba(0,0,0,0.12)' },
      default: { shadowColor: '#000', shadowOffset: { width: 0, height: 1 }, shadowOpacity: 0.3, shadowRadius: 1.5, elevation: 3 },
    }),
  },
});

export default RaisedCenterAction;
